module.exports = __webpack_public_path__ + "img/hotel4.e46c990e.png";